import type { LensCard, LensSection } from '~/types/leLens';

/** Layout drafts may merge refreshed card content, but cannot replace a newer
 * card list, section structure or saved frame with the draft's older layout. */
export function layoutWorkspaceStructure(sections: ReadonlyArray<LensSection>, cards: ReadonlyArray<LensCard>): string {
  return JSON.stringify([
    sections.map((section) => [section.id, section.title]),
    cards.map((card) => [
      card.id,
      card.type,
      card.section ?? null,
      card.size ?? null,
      card.height ?? null,
      card.layout ? [card.layout.x, card.layout.y, card.layout.w, card.layout.h] : null,
    ]),
  ]);
}
